import { useEffect, useState } from 'react';
import { getSiteSettings } from '@/lib/siteSettings';
import { useLocation } from 'react-router-dom';


let settingsCache = null;

const TrackingScripts = () => {
  const [settings, setSettings] = useState(settingsCache);
  const location = useLocation();

  useEffect(() => {
    if (!settingsCache) {
      getSiteSettings().then(r => {
        settingsCache = r.data;
        setSettings(r.data);
      }).catch(() => {});
    }
  }, []);

  // Meta Pixel
  useEffect(() => {
    if (!settings?.meta_pixel_id) return;
    const id = settings.meta_pixel_id;
    if (window.fbq) return;

    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
      (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${id}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1"/>`;
    document.body.appendChild(noscript);
  }, [settings?.meta_pixel_id]);

  // Meta Pixel page view on route change
  useEffect(() => {
    if (window.fbq) window.fbq('track', 'PageView');
  }, [location.pathname]);

  // Google Analytics GA4
  useEffect(() => {
    if (!settings?.google_analytics_id) return;
    const id = settings.google_analytics_id;
    if (document.querySelector(`script[src*="${id}"]`)) return;

    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(gtagScript);

    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${id}');
    `;
    document.head.appendChild(inlineScript);
  }, [settings?.google_analytics_id]);

  // GA4 page view on route change
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', settings?.google_analytics_id, { page_path: location.pathname + location.search });
    }
  }, [location.pathname, location.search, settings?.google_analytics_id]);

  // Pinterest Tag
  useEffect(() => {
    if (!settings?.pinterest_tag_id) return;
    const id = settings.pinterest_tag_id;
    if (window.pintrk) return;

    const script = document.createElement('script');
    script.innerHTML = `
      !function(e){if(!window.pintrk){window.pintrk=function(){window.pintrk.queue.push(Array.prototype.slice.call(arguments))};
      var n=window.pintrk;n.queue=[],n.version="3.0";
      var t=document.createElement("script");t.async=!0,t.src=e;
      var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}
      ("https://s.pinimg.com/ct/core.js");
      pintrk('load', '${id}');
      pintrk('page');
    `;
    document.head.appendChild(script);
  }, [settings?.pinterest_tag_id]);

  // Pinterest page view on route change
  useEffect(() => {
    if (window.pintrk) window.pintrk('page');
  }, [location.pathname]);

  return null;
};

// Tracking event helpers
export const trackAddToCart = (artwork) => {
  if (window.fbq) window.fbq('track', 'AddToCart', { content_name: artwork.title, content_ids: [artwork.id], content_type: 'product', value: artwork.price, currency: 'INR' });
  if (window.gtag) window.gtag('event', 'add_to_cart', { items: [{ item_id: artwork.id, item_name: artwork.title, price: artwork.price }] });
  if (window.pintrk) window.pintrk('track', 'addtocart', { product_id: artwork.id, product_name: artwork.title, value: artwork.price, currency: 'INR' });
};

export const trackPurchase = (orderId, total, items) => {
  if (window.fbq) window.fbq('track', 'Purchase', { value: total, currency: 'INR', content_ids: items.map(i => i.id), num_items: items.length });
  if (window.gtag) window.gtag('event', 'purchase', { transaction_id: orderId, value: total, currency: 'INR', items: items.map(i => ({ item_id: i.id, item_name: i.title, price: i.price })) });
  if (window.pintrk) window.pintrk('track', 'checkout', { value: total, currency: 'INR', order_id: orderId });
};

export const trackViewContent = (artwork) => {
  if (window.fbq) window.fbq('track', 'ViewContent', { content_name: artwork.title, content_ids: [artwork.id], content_type: 'product', value: artwork.price, currency: 'INR' });
  if (window.gtag) window.gtag('event', 'view_item', { items: [{ item_id: artwork.id, item_name: artwork.title, price: artwork.price }] });
  if (window.pintrk) window.pintrk('track', 'pagevisit', { product_id: artwork.id });
};

export default TrackingScripts;
